import { IsNumberString } from 'class-validator';

export class GiftCardTopupActivateRequestDto {
  cardNumber: string;

  constructor(cardNumber: string) {
    this.cardNumber = cardNumber;
  }
}
